export default "/_next/static/images/icon-b6db8701bf751c5decf7fb0341210c75.png";